import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { ElementType, FC } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

export type SettingsMenuItemType = {
	icon: ElementType;
	label: string;
	iconBg: string;
	iconColor: string;
	onClick?: () => void;
};

type Props = {
	item: SettingsMenuItemType;
	showDivider: boolean;
};

export const SettingsMenuItem: FC<Props> = ({ item, showDivider }) => {
	const theme = useTheme();
	const Icon = item.icon;

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.6}
			px={1.6}
			py={1.2}
			onClick={item.onClick}
			sx={{
				cursor: item.onClick ? "pointer" : "default",
				"&:active": item.onClick
					? { bgcolor: theme.palette.grey[50] }
					: undefined,
				borderBottom: showDivider
					? `1px solid ${theme.palette.grey[100]}`
					: undefined,
			}}
		>
			<IconBox bg={item.iconBg} shape="circle">
				<Icon size={20} color={item.iconColor} />
			</IconBox>
			<Typography variant="subtitle1" flex={1}>
				{item.label}
			</Typography>
			{item.onClick && (
				<ChevronRight size={20} color={theme.palette.grey[400]} />
			)}
		</Stack>
	);
};
